var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import { Box, Tabs, Tab, Typography, Grid, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { DashboardKpiCard, } from "../../../components/dashboard/DashboardKpiCard";
import { EmptyDashboardState } from "../../../components/dashboard/EmptyDashboardState";
import { DEFAULT_KPI_CARD_VISUALS, getKpiCardVisuals, } from "../../../components/dashboard/kpi-icons/kpiIconRegistry";
import { ChartRenderer } from "../../../shared/charts";
import { MulheresFilters } from "./MulheresFilters";
import { useMulheresCharts } from "../hooks/useMulheresCharts";
import { useMulheresKpis } from "../hooks/useMulheresKpis";
import { DeamsTerritoryInfoModal } from "./DeamsTerritoryInfoModal";
import { TerritorialCoverageModal } from "./TerritorialCoverageModal";
import { useDashboardCatalog } from "../../../shared/dashboard/hooks/useDashboardCatalog";
import { useMulheresFilters } from "../hooks/useMulheresFilters";
import { formatNumericValue, getChartDataset, parseNumericValue, resolveLabelAndValueKeys, } from "../../../utils/chartData";
import { normalizeDisplayText } from "../../../utils/displayText";
import { ShareCurrentViewButton } from "../../../shared/components/ShareCurrentViewButton";
import { getChartGridMd } from "../../../pages/painel/ChartCard";
var normalizeFileName = function (title) {
    return title
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .slice(0, 50) || "grafico";
};
function exportChartAsPdf(node, title) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var bounds, captureWidth, captureHeight, canvas, isLandscape, pageWidth, pageHeight, pdf, now, pad, fileBaseName, fileName;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    bounds = node.getBoundingClientRect();
                    captureWidth = Math.ceil(Math.max(node.scrollWidth, bounds.width));
                    captureHeight = Math.ceil(Math.max(node.scrollHeight, node.offsetHeight, bounds.height));
                    return [4 /*yield*/, html2canvas(node, {
                            scale: 2,
                            backgroundColor: "#FFFFFF",
                            useCORS: true,
                            width: captureWidth,
                            height: captureHeight,
                            windowWidth: captureWidth,
                            windowHeight: captureHeight,
                            scrollX: 0,
                            scrollY: 0,
                        })];
                case 1:
                    canvas = (_a = (_d.sent())) !== null && _a !== void 0 ? _a : {
                        width: 1200,
                        height: 800,
                        toDataURL: function () { return "data:image/png;base64,"; },
                    };
                    isLandscape = canvas.width >= canvas.height;
                    pageWidth = isLandscape ? 842 : 595;
                    pageHeight = (canvas.height * pageWidth) / canvas.width;
                    pdf = new jsPDF({
                        orientation: isLandscape ? "landscape" : "portrait",
                        unit: "pt",
                        format: [pageWidth, pageHeight],
                    });
                    now = new Date();
                    pad = function (v) { return v.toString().padStart(2, "0"); };
                    fileBaseName = normalizeFileName(title) || "grafico";
                    fileName = "".concat(fileBaseName, "-").concat(pad(now.getFullYear() % 100)).concat(pad(now.getDate())).concat(pad(now.getMonth() + 1)).concat(pad(now.getHours())).concat(pad(now.getMinutes())).concat(pad(now.getSeconds()), ".pdf");
                    (_b = pdf.addImage) === null || _b === void 0 ? void 0 : _b.call(pdf, canvas.toDataURL("image/png"), "PNG", 0, 0, pageWidth, pageHeight);
                    (_c = pdf.save) === null || _c === void 0 ? void 0 : _c.call(pdf, fileName);
                    return [2 /*return*/];
            }
        });
    });
}
var DEAMS_MONTHLY_SERIES_CHART_ID = "mulheres.bos_deams.deams_monthly_series";
var DEAMS_MONTHLY_SERIES_CHART_TITLE = "série mensal de deams";
function isDeamsMonthlySeriesChart(chart) {
    return (chart.id === DEAMS_MONTHLY_SERIES_CHART_ID ||
        chart.title.trim().toLocaleLowerCase("pt-BR") ===
            DEAMS_MONTHLY_SERIES_CHART_TITLE);
}
function MulheresChartCard(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f;
    var chart = _a.chart;
    var cardRef = useRef(null);
    var _g = useState(false), isExporting = _g[0], setIsExporting = _g[1];
    var gridMd = getChartGridMd(chart.chartType);
    var isDeamsChart = isDeamsMonthlySeriesChart(chart);
    var handleDownload = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!cardRef.current || !chart.data || isExporting)
                        return [2 /*return*/];
                    setIsExporting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, exportChartAsPdf(cardRef.current, chart.title)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsExporting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Grid, __assign({ item: true, xs: 12, md: gridMd, "data-testid": "mulheres-chart-grid-item", "data-grid-md": String(gridMd) }, { children: _jsxs(Box, __assign({ ref: cardRef, "data-testid": "mulheres-chart-card", sx: {
                background: "#fff",
                borderRadius: "16px",
                border: "1px solid #E5E7EB",
                p: isDeamsChart ? { xs: 2.5, sm: "24px 28px" } : { xs: 2, sm: 2.5 },
                height: "auto",
                minHeight: isDeamsChart ? 1200 : 320,
                minWidth: 0,
                overflow: "visible",
                display: "flex",
                flexDirection: "column",
            } }, { children: [_jsxs(Box, __assign({ sx: {
                        display: "flex",
                        alignItems: isDeamsChart ? "center" : "flex-start",
                        justifyContent: "space-between",
                        mb: isDeamsChart ? 3.5 : 1.5,
                        gap: 1,
                        flexDirection: { xs: "column", sm: "row" },
                    } }, { children: [_jsx(Box, __assign({ sx: { minWidth: 0, width: "100%" } }, { children: isDeamsChart ? (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 700,
                                            fontSize: "0.95rem",
                                            color: "#111827",
                                            lineHeight: 1.2,
                                        } }, { children: "An\u00E1lise De Evolu\u00E7\u00E3o De DEAMs: Tend\u00EAncias Mensais De Ocorr\u00EAncias" })), _jsx(Typography, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 400,
                                            fontSize: "0.72rem",
                                            color: "#6B7280",
                                            lineHeight: 1.4,
                                            mt: 0.5,
                                        } }, { children: "Vis\u00E3o padr\u00E3o por territ\u00F3rio com detalhamento autom\u00E1tico por delegacia quando um recorte espec\u00EDfico \u00E9 selecionado." }))] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 700,
                                            fontSize: { xs: "1rem", sm: "0.9rem" },
                                            color: "#1F2937",
                                            lineHeight: 1.3,
                                        } }, { children: chart.title })), chart.subtitle && (_jsx(Typography, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontSize: { xs: "0.82rem", sm: "0.75rem" },
                                            color: "#4B5563",
                                            mt: 0.3,
                                        } }, { children: chart.subtitle })))] })) })), _jsx(Button, __assign({ size: "small", startIcon: _jsx(DownloadIcon, { sx: { fontSize: "16px !important" } }), disabled: !chart.data || isExporting, variant: "outlined", onClick: handleDownload, sx: {
                                textTransform: "none",
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 600,
                                fontSize: isDeamsChart ? "0.875rem" : "0.75rem",
                                borderRadius: "8px",
                                borderColor: isDeamsChart ? "#D1D5DB" : "#E5E7EB",
                                color: isDeamsChart ? "#374151" : "#6B7280",
                                px: isDeamsChart ? 2 : 1.5,
                                py: isDeamsChart ? 1 : 0.5,
                                minWidth: { xs: 112, sm: "auto" },
                                "&:hover": {
                                    borderColor: "#034EA2",
                                    color: "#034EA2",
                                },
                            } }, { children: "Baixar" }))] })), chart.error ? (_jsx(EmptyDashboardState, { minHeight: 220 })) : (_jsx(Box, __assign({ sx: { minWidth: 0, overflow: "visible" } }, { children: _jsx(ChartRenderer, { data: (_b = chart.data) !== null && _b !== void 0 ? _b : {
                            columns: [],
                            dataset: [],
                            chart: (_c = chart.chartType) !== null && _c !== void 0 ? _c : "bar",
                            aggregation: null,
                            filters: null,
                        }, title: chart.title, bare: true, chartType: (_f = (_e = (_d = chart.data) === null || _d === void 0 ? void 0 : _d.chart) !== null && _e !== void 0 ? _e : chart.chartType) !== null && _f !== void 0 ? _f : "bar", chartGroup: "mulheres", loading: chart.loading || !chart.data }) })))] })) })));
}
function extractKpiDisplay(payload, extract, detailSuffix) {
    var _a;
    if (!payload) {
        return { value: "...", detail: detailSuffix !== null && detailSuffix !== void 0 ? detailSuffix : "" };
    }
    var dataset = getChartDataset(payload);
    var _b = resolveLabelAndValueKeys(payload, dataset), labelKey = _b.labelKey, valueKey = _b.valueKey;
    var items = dataset.map(function (item) {
        var _a, _b, _c;
        return ({
            label: String((_a = item[labelKey]) !== null && _a !== void 0 ? _a : ""),
            value: parseNumericValue((_c = (_b = item[valueKey]) !== null && _b !== void 0 ? _b : item.value) !== null && _c !== void 0 ? _c : 0),
        });
    });
    if (items.length === 0) {
        return { value: "—", detail: detailSuffix !== null && detailSuffix !== void 0 ? detailSuffix : "sem dados" };
    }
    if (extract === "raw_value") {
        var firstItem = dataset[0];
        var rawValue = firstItem.value;
        var rawDetail = firstItem.detail;
        var value = typeof rawValue === "number"
            ? formatNumericValue(rawValue)
            : typeof rawValue === "string" && /^-?\d+(?:[.,]\d+)?$/.test(rawValue)
                ? formatNumericValue(parseNumericValue(rawValue))
                : String(rawValue !== null && rawValue !== void 0 ? rawValue : "—");
        return {
            value: value,
            detail: String((_a = rawDetail !== null && rawDetail !== void 0 ? rawDetail : detailSuffix) !== null && _a !== void 0 ? _a : ""),
        };
    }
    if (extract === "total") {
        var total = items.reduce(function (acc, item) { return acc + item.value; }, 0);
        return {
            value: formatNumericValue(total),
            detail: detailSuffix
                ? "".concat(formatNumericValue(total), " ").concat(detailSuffix)
                : "",
        };
    }
    if (extract === "max_entry") {
        var target = __spreadArray([], items, true).sort(function (a, b) { return b.value - a.value; })[0];
        return {
            value: /^\d{4}-\d{2}/.test(target.label)
                ? target.label.slice(0, 4)
                : normalizeDisplayText(target.label),
            detail: detailSuffix
                ? "".concat(formatNumericValue(target.value), " ").concat(detailSuffix)
                : "",
        };
    }
    return { value: "—", detail: detailSuffix !== null && detailSuffix !== void 0 ? detailSuffix : "" };
}
function buildGenericMulheresKpis(items) {
    return (items !== null && items !== void 0 ? items : []).map(function (item) {
        var iconConfig = getKpiCardVisuals(item.id);
        var display = extractKpiDisplay(item.payload, item.extract, item.detail_suffix);
        return __assign(__assign({}, iconConfig), { label: item.label, value: display.value, detail: display.detail, loading: false });
    });
}
export function MulheresTabContent(_a) {
    var _b, _c, _d;
    var activeSubTab = _a.activeSubTab, onSubTabChange = _a.onSubTabChange, onShareCopied = _a.onShareCopied;
    var _e = useState(false), isTerritorialCoverageOpen = _e[0], setIsTerritorialCoverageOpen = _e[1];
    var _f = useState(false), isDeamsTerritoryInfoOpen = _f[0], setIsDeamsTerritoryInfoOpen = _f[1];
    var _g = useMulheresFilters(), filters = _g.filters, handleFilterChange = _g.handleFilterChange, resetFilters = _g.resetFilters;
    var _h = useDashboardCatalog(), catalog = _h.catalog, catalogLoading = _h.loading;
    var mulheresDomain = catalog === null || catalog === void 0 ? void 0 : catalog.domains.find(function (domain) { return domain.id === "mulheres"; });
    var sectionSlugs = ((_b = mulheresDomain === null || mulheresDomain === void 0 ? void 0 : mulheresDomain.sections) !== null && _b !== void 0 ? _b : []).map(function (section) { return section.slug; });
    var resolvedSubTab = sectionSlugs.includes(activeSubTab)
        ? activeSubTab
        : (_c = sectionSlugs[0]) !== null && _c !== void 0 ? _c : "visao-geral";
    var dynamicSection = mulheresDomain === null || mulheresDomain === void 0 ? void 0 : mulheresDomain.sections.find(function (section) { return section.slug === resolvedSubTab; });
    var charts = useMulheresCharts(resolvedSubTab, filters, dynamicSection);
    var groupedKpisQuery = useMulheresKpis(resolvedSubTab, filters, dynamicSection);
    var genericKpis = buildGenericMulheresKpis(groupedKpisQuery.data);
    var shouldShowTerritorialCoverageButton = resolvedSubTab === "visao-geral" ||
        resolvedSubTab === "feminicidios" ||
        resolvedSubTab === "perfil-vitimas" ||
        resolvedSubTab === "tempo-territorio";
    var shouldShowDeamsTerritoryButton = resolvedSubTab === "bos-deams";
    var handleTabChange = function (_, newValue) {
        onSubTabChange(newValue);
    };
    return (_jsxs(Box, __assign({ sx: { width: "100%" } }, { children: [_jsxs(Box, __assign({ sx: {
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    gap: 2,
                    flexWrap: "wrap",
                } }, { children: [_jsx(Tabs, __assign({ value: resolvedSubTab, onChange: handleTabChange, variant: "scrollable", scrollButtons: "auto", allowScrollButtonsMobile: true, sx: {
                            "& .MuiTab-root": {
                                textTransform: "none",
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 500,
                                fontSize: "0.9rem",
                                color: "#6B7280",
                                minWidth: "auto",
                                px: 2,
                                "&.Mui-selected": { color: "#034EA2", fontWeight: 700 },
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#034EA2",
                                height: 2,
                            },
                        } }, { children: ((_d = mulheresDomain === null || mulheresDomain === void 0 ? void 0 : mulheresDomain.sections) !== null && _d !== void 0 ? _d : []).map(function (tab) { return (_jsx(Tab, { label: tab.label, value: tab.slug }, tab.slug)); }) })), _jsxs(Box, __assign({ sx: {
                            pb: 1,
                            display: "flex",
                            gap: 1,
                            alignItems: "center",
                            flexWrap: "wrap",
                        } }, { children: [shouldShowTerritorialCoverageButton && (_jsx(Button, __assign({ "data-testid": "mulheres-territorial-coverage-button", size: "small", startIcon: _jsx(InfoOutlinedIcon, { sx: { fontSize: "16px !important" } }), onClick: function () { return setIsTerritorialCoverageOpen(true); }, sx: {
                                    px: 0,
                                    minWidth: 0,
                                    textTransform: "none",
                                    color: "#034EA2",
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 600,
                                    justifyContent: "flex-start",
                                    "&:hover": {
                                        background: "transparent",
                                        color: "#02356F",
                                    },
                                } }, { children: "Ver abrang\u00EAncia territorial" }))), shouldShowDeamsTerritoryButton && (_jsx(Button, __assign({ "data-testid": "mulheres-deams-territory-button", size: "small", startIcon: _jsx(InfoOutlinedIcon, { sx: { fontSize: "16px !important" } }), onClick: function () { return setIsDeamsTerritoryInfoOpen(true); }, sx: {
                                    px: 0,
                                    minWidth: 0,
                                    textTransform: "none",
                                    color: "#034EA2",
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 600,
                                    justifyContent: "flex-start",
                                    "&:hover": {
                                        background: "transparent",
                                        color: "#02356F",
                                    },
                                } }, { children: "Ver abrang\u00EAncia territorial" }))), _jsx(ShareCurrentViewButton, { onCopied: onShareCopied })] }))] })), _jsxs(Box, __assign({ sx: { py: 3 } }, { children: [_jsx(MulheresFilters, { dynamicSubtab: dynamicSection, filters: filters, onChange: handleFilterChange, onClear: resetFilters }), groupedKpisQuery.isLoading && (_jsx(Box, __assign({ sx: { mb: 8, pb: 2 } }, { children: _jsx(Grid, __assign({ container: true, spacing: 2, alignItems: "flex-start" }, { children: Array.from({ length: 4 }).map(function (_, index) { return (_jsx(Grid, __assign({ item: true, xs: 12, sm: 6, md: 3, sx: { display: "flex" } }, { children: _jsx(DashboardKpiCard, { card: __assign(__assign({ label: "Carregando", value: "...", detail: "..." }, DEFAULT_KPI_CARD_VISUALS), { loading: true }) }) }), index)); }) })) }))), genericKpis.length > 0 && (_jsx(Box, __assign({ sx: { mb: 8, pb: 2 } }, { children: _jsx(Grid, __assign({ container: true, spacing: 2, alignItems: "flex-start" }, { children: genericKpis.map(function (kpi) { return (_jsx(Grid, __assign({ item: true, xs: 12, sm: 6, md: 3, sx: { display: "flex" } }, { children: _jsx(DashboardKpiCard, { card: kpi }) }), kpi.label)); }) })) }))), !catalogLoading && !dynamicSection && (_jsx(EmptyDashboardState, { minHeight: 220 })), _jsx(Box, { children: _jsx(Grid, __assign({ container: true, spacing: 2.5 }, { children: charts.map(function (chart) { return (_jsx(MulheresChartCard, { chart: chart }, chart.id)); }) })) })] })), _jsx(TerritorialCoverageModal, { open: isTerritorialCoverageOpen, onClose: function () { return setIsTerritorialCoverageOpen(false); } }), _jsx(DeamsTerritoryInfoModal, { open: isDeamsTerritoryInfoOpen, onClose: function () { return setIsDeamsTerritoryInfoOpen(false); } })] })));
}
